import { WorkoutExercise } from '@src/data/workout-exercise'

export enum WorkoutType {
  CUSTOM = 'custom',
  HOME = 'home'
}

export enum WorkoutDataState {
  TRASHED = 'trashed',
  PUBLISHED = 'published',
  DISABLED = 'disabled'
}

export enum HolderType {
  CLUB = 'Club',
  MEMBER = 'Member'
}

export default class WorkoutData {

  public id: number | null
  public name: string = ''
  public stationLocked: boolean = false
  public type: WorkoutType = WorkoutType.CUSTOM
  public exerciseCount: number = 0
  public continuousWorkout: boolean = false
  public circleWorkout: boolean = true
  public estimatedDurationInMin: number = 0
  public holderType: HolderType
  public holderId: number
  public createdAt: string
  public createdBy: string
  public platformUpdatedAt: string | null // update done by trainer (other updates are possible by dev team)
  public platformUpdatedBy: string | null // update done by trainer (other updates are possible by dev team)

  public equipment: string[] = []
  public estimatedMetValue: number = 0
  public rating: number = 0

  public workoutExercises: WorkoutExercise[] = []

  public certified: boolean = false

  public previewImage: string

  public default: boolean // a default workout (station or home) is generated as active workout, automatically, by BE
  public hidden: boolean
  public state: WorkoutDataState
  public categories: number[]
  public restartIfUncompleted: boolean = true
  public screenCountdownLen: number
  public screenSummaryLen: number
  public position: number

  constructor (attributes?) {
    Object.assign(this, attributes)
    this.equipment = this.equipment.filter(equipment => equipment && equipment !== '')
    this.setDefaultDisplayImage()
  }

  isCertified (): boolean {
    return this.certified
  }

  isStationWorkout (): boolean {
    return this.type === 'custom'
  }

  isHomeWorkout (): boolean {
    return this.type === 'home'
  }

  isMemberTrainerWorkout (): boolean {
    return this.holderType === HolderType.MEMBER
  }

  isWorkoutByType (type: string | undefined, locationType: string = 'custom') {
    if (locationType !== this.type) return false
    if (!type) return true

    if (type === 'certified') return this.isCertified() && !this.isMemberTrainerWorkout()
    if (type === 'non-certified') return !this.isCertified() && !this.isMemberTrainerWorkout()
    if (type === 'member-trainer') return this.isMemberTrainerWorkout()
    if (type === 'hidden') return this.hidden
    if (type === 'show') return !this.hidden
  }

  get displayImage (): string {
    return this.previewImage
  }

  setDefaultDisplayImage () {
    if (!this.previewImage && this.id) {
      this.previewImage = `/assets/icon/brand/default-workout/${this.id % 30}.jpg`
    }
  }
}
